import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';

@Injectable({providedIn: 'root'})
export class LocationService {

  private readonly apiPrefix = '/public/locations';

  constructor(
    private api: ApiService,
  ) {
  }

  getCities(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/cities`);
  }
}
